module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-256.a9d53b96.svg";